import { regExp } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

export default function(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${this.service}.labels.name`),
        hint: this.getTranslate('hints.max.50'),
        disabled: this.disabled,
        dense: true,
        required: true,
        autofocus: this.isNew,
        details: true,
        mask: regExp.titleOtpSettingsSoft
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
